<template>
  <div class="dggx-con">
    <div class="dggx-list">
      <div class="dggx-item" v-for="item,ind in kcjsList" :key="ind" @click="showVideo(item)">
        <div class="left-img" :style="`background-image: url(${item.cover})`"></div>
        <div class="right-info">
          <div class="item-title">{{item.title}}</div>
          <div class="info-text">
            {{item.abstract}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="pageNum > 1" class="pagination">
      <a-pagination v-model="page" :total="total" :page-size="pageSize" @change="onPagesChange" size="small" :item-render="itemRender" />
    </div>
    <div v-else-if="kcjsList.length <= 0" class="noData-box">
      <img src="../../../../assets/image/jsckzyxy/empty.png" alt="" />
      <div class="text">暂无相关内容</div>
    </div>
    <div class="spin-con" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <videoModal :videoShow="videoShow" :videoInfo="videoInfo" :videoTitle="videoInfo.title" @closeModal="videoShow = false"></videoModal>

  </div>
</template>

<script>
import services from "../../../../assets/js/services.js";
import { mapActions } from "vuex";
import utils from "../../../../assets/js/utils.js";
import videoModal from "../../components/video-modal.vue";

export default {
  props: {
    activeObj: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    videoModal
  },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      specialId: services.KJQG_SPECIAL_ID,
      kcjsList: [],
      page: 1,
      total: 0,
      pageSize: 8,
      pageNum: 0,
      loading: false,
      videoShow: false,
      videoInfo: {}
      //   activeCategroy: ""
    }
  },
  watch: {
    activeObj: {
      handler(newVal) {
        // this.activeCategroy = newVal.children[0].title
        this.page = 1
        this.getkjhzList()
      },
      immediate: true,
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getAppsLoginUserInfo"]),
    async getkjhzList() {
      this.loading = true;
      let res = await services.getAreaSzztkLists({
        page: this.page,
        length: this.pageSize,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        column_name: this.activeObj.title,
        order_by: "asc"
      });
      if (res.code == "0000" && res.data.items.length > 0) {
        this.kcjsList = res.data.items
        this.pageNum = res.data.page_num;
        this.total = res.data.total;
      } else {
        this.kcjsList = [];
        this.pageNum = 0;
        this.total = 0;
      }
      this.loading = false;

    },
    setActiveTit(item) {
      this.activeCategroy = item.title
      this.page = 1;
      this.getkjhzList();
    },
    onPagesChange(val) {
      this.page = val;
      this.getkjhzList();
    },
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
      showVideo(item) {
      if (item.tencent_vod_file_id && item.tencent_vod_app_id) {
        this.videoInfo = item,
          this.videoShow = true
      }
    },
  }
}
</script>

<style lang="less" scoped>
.dggx-con {
  .dggx-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .dggx-item {
      width: 436px;
      height: 240px;
      background-image: url("../../../../assets/image/kjqg/dggx/dggx-item.png");
      background-size: cover;
      display: flex;
      border-bottom: 4px solid #92c4ff;
      margin-bottom: 32px;
      cursor: pointer;
      .left-img {
        width: 186px;
        height: 100%;
        background-position: center;
        background-size: cover;
      }
      .right-info {
        flex: 1;
        padding: 20px 20px 0;
        overflow: hidden;
        .item-title {
          font-weight: bold;
          font-size: 20px;
          color: #273c5c;
          //   line-height: 36px;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          &::after {
            content: "";
            display: block;
            width: 209px;
            height: 8px;
            background-image: url("../../../../assets/image/kjqg/index/kcjs/kcjs-item-split.png");
            background-size: cover;
            background-position: center;
            margin-top: 5px;
            // bottom: -10px;
          }
        }
        .info-text {
          font-weight: 400;
          font-size: 16px;
          color: #494d53;
          margin-top: 13px;
          line-height: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5; /* 控制显示的行数 */
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 45px;
    z-index: 2;
    ::v-deep.ant-pagination {
      .ant-pagination-prev,
      .ant-pagination-next {
        margin: 0 15px;
        a {
          color: #1869e4;
        }
      }
      .ant-pagination-item {
        margin: 0 5px;
        border-radius: 0;
        a {
          color: #1869e4;
        }
        &.ant-pagination-item-active {
          background-color: #1869e4;
          border: 1px solid transparent;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
.spin-con {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  z-index: 999;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>